<template>
  <main :class="style.contactInfo">
    <div :class="style.contact">
      <div>
        <span>Введите ваше ФИО</span>
        <input
          autocomplete="name"
          v-model="chose.ClientFullName"
          type="text"
          placeholder="Иванов Иван Иванович"
        />
      </div>
      <div>
        <span>Введите вашу дату рождения</span>
        <input
          v-imask="{mask: '00.00.0000'}"
          @input="setBirthday($event)"
          autocomplete="bday"
          type="text"
          placeholder="18.09.1984"
        />
      </div>
      <div>
        <span>Введите ваш телефон</span>
        <PreviousPhoneInput v-model="chose.ClientPhone" />
      </div>
      <div>
        <span>Комментарий</span>
        <textarea
          v-model="chose.comment"
          placeholder="Интересует удаление зуба мудрости"
        ></textarea>
      </div>
    </div>
    <button v-if="sendStaus == 'Loading'">
      <LoaderTextButton />
    </button>
    <button
      :class="style.notActive + ' ' + style.errorSend"
      v-else-if="sendStaus == 'Error'"
    >
      Ошибка
    </button>
    <button :class="style.notActive" v-else-if="!isPhoneMasked(chose)">
      Записаться
    </button>
    <button v-else @click="setChose('Запись')">Записаться</button>
    <a target="_blank" href="https://readds.ru/policy"
      >Нажимая на кнопку, вы даёте согласие на обработку персональных данных и
      соглашаетесь с политикой конфиденциальности.</a
    >
  </main>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
import PreviousPhoneInput from "@/elements/phoneInput/PreviousPhoneInput.vue";
import {isPhoneMasked} from "../ScriptsWidget";
import LoaderTextButton from "@/elements/loaderTextButton/LoaderTextButton.vue";

interface monthList {
  [key: string]: string;
}
export default defineComponent({
  name: "ContactFormWidget",
  components: {PreviousPhoneInput, LoaderTextButton},

  data() {
    return {
      style,
      isPhoneMasked
    };
  },
  mounted() {
    document.addEventListener("keydown", this.keyboard);
    const mounthAndYear = this.selectedMonthStr.split(" ");
    const mounth = mounthAndYear[0];
    const year = mounthAndYear[1];
    const date = new Date(
      Number(year),
      Number(this.getMonth(mounth)) - 1,
      Number(this.selectedDayStr)
    );
    const weekday = date.getDay() == 0 ? 6 : date.getDay() - 1;
    this.stages[2] = [
      "3",
      "Дата и время",
      this.getWeekday(weekday) +
        ", " +
        this.selectedDayStr +
        " " +
        this.declensionMounth(mounth) +
        ", " +
        this.selectedTime
    ];
    this.stages[3] = [...this.hints["shape"]];
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.keyboard);
  },
  methods: {
    declensionMounth(mounth: string) {
      const monthList: monthList = {
        Январь: "января",
        Февраль: "февраля",
        Март: "марта",
        Апрель: "aпреля",
        Май: "мая",
        Июнь: "июня",
        Июль: "июля",
        Август: "aвгуста",
        Сентябрь: "cентября",
        Октябрь: "октября",
        Ноябрь: "ноября",
        Декабрь: "декабря"
      };
      return monthList[mounth];
    },
    getWeekday(id: number) {
      const dayList = [
        "Понедельник",
        "Вторник",
        "Среда",
        "Четверг",
        "Пятница",
        "Суббота",
        "Воскресение"
      ];
      return dayList[id];
    },
    getMonth(id: string) {
      const monthList: monthList = {
        "01": "Январь",
        "02": "Февраль",
        "03": "Март",
        "04": "Апрель",
        "05": "Май",
        "06": "Июнь",
        "07": "Июль",
        "08": "Август",
        "09": "Сентябрь",
        10: "Октябрь",
        11: "Ноябрь",
        12: "Декабрь",

        Январь: "01",
        Февраль: "02",
        Март: "03",
        Апрель: "04",
        Май: "05",
        Июнь: "06",
        Июль: "07",
        Август: "08",
        Сентябрь: "09",
        Октябрь: "10",
        Ноябрь: "11",
        Декабрь: "12"
      };
      return monthList[id];
    },
    keyboard(e: KeyboardEvent) {
      if (this.chose.ClientPhone.length < 16 || e.code != "Enter") {
        return;
      }
      this.setChose("Запись");
    },
    setBirthday(event: Event) {
      let target = event.target as HTMLInputElement;
      if (!target) {
        return;
      }
      let date = target.value;
      const pattern = new RegExp(
        `(^\\d{${date.length % 8}})(\\d{2})(\\d{2})(\\d{4})`
      );
      const formatDate = date.replace(pattern, "$2.$3.$4").slice(0, 10);
      this.chose.birthdate = formatDate;
      target.value = formatDate;
    },
    async setChose(name: string) {
      this.$widgetStore.setChose(name);
    }
  },

  computed: {
    sendStaus() {
      return this.$widgetStore.getSendStatus;
    },
    getClinic() {
      return this.$widgetStore.clinic;
    },
    appointment() {
      return this.$widgetStore.getAppointment;
    },
    chose() {
      return this.$widgetStore.getChose;
    },
    stages() {
      return this.$widgetStore.getStages;
    },
    selectedMonthStr() {
      return this.$widgetStore.getSelectedMonthStr;
    },
    selectedDayStr() {
      return this.$widgetStore.getSelectedDayStr;
    },
    selectedTime() {
      return this.$widgetStore.getSelectedTime;
    },
    hints() {
      return this.$widgetStore.getHints;
    }
  }
});
</script>
